import React from "react";

function Navbar({ left, center, right }) {
  return (
    <div className="flex items-center bg-primary text-white py-4">
      {left}
      <div className="font-bold flex-grow text-center">{center}</div>
      {right}
    </div>
  );
}

export default Navbar;
